import { useStrictContext } from '@funtech-int/rival-react';

import { MovieModal } from '../lib/movieModal';
import { MovieModalContext } from '../constants';

export function useMovieModal(): MovieModal {
    return useStrictContext(MovieModalContext);
}
